"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Container = _interopRequireDefault(require("@material-ui/core/Container"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var PageContainer = (0, _styledComponents.default)(_Container.default).attrs({
  maxWidth: 'xl'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // height of fixed appbar + 20px extra margin\n  margin-top: 84px;\n"])));
exports.PageContainer = PageContainer;